/**
 * Returns `true` if no modifier key is pressed for the event.
 */
export function isEventWithNoModKeys(event) {
    return !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}
